module.exports = __webpack_public_path__ + "img/pro_two.42e29fc8.jpg";